import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useState } from "react";
import { useMutation } from "react-query";
import { publicComicImportSources } from "../../../core/constants";
import { submitComic } from "../../../services/readingOrdersApi";

const SubmitComicModal = ({ isOpen, onClose }) => {
  const [creationMode, setCreationMode] = useState("1");
  const [importUrl, setImportUrl] = useState("");
  const toast = useToast();
  const [comic, setComic] = useState(null);
  const { isLoading, mutateAsync } = useMutation(({ source, url }) => {
    return submitComic(source, url);
  });

  const resetForm = () => {
    setComic(null);
    setImportUrl(null);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    mutateAsync({
      source: publicComicImportSources[creationMode].sourceKey,
      url: importUrl,
    })
      .then(({ data }) => {
        toast({
          title: "Comic imported.",
          description: `${data.title} imported.`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setComic(data);
      })
      .catch((error) => {
        console.error(error);
        // handle error
        toast({
          title: "Error occured",
          description: JSON.stringify(error.data),
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <form onSubmit={(e) => onSubmit(e)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Submit a missing comic</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!comic ? (
              <Box>
                <Text as="p" pb="6" fontSize="sm">
                  We want to make sure you have all your favorites in your
                  reading list. If you don't see the comic you're looking for,
                  no worries! Fill in the details and we'll handle the rest,
                  making sure it's available for you and other Redwing users.
                </Text>
                <FormControl>
                  <RadioGroup
                    onChange={(value) => setCreationMode(value)}
                    value={creationMode}
                  >
                    <Stack direction="column">
                      <Text>Import using a URL from:</Text>
                      {Object.keys(publicComicImportSources).map((key) => (
                        <Radio key={key} value={key}>
                          {publicComicImportSources[key].sourceLabel}
                        </Radio>
                      ))}
                      {/* <Radio key={0} value="0">
                    Create manually
                  </Radio> */}
                    </Stack>
                  </RadioGroup>
                  <Radio key={"dc"} value={"dc"} disabled pt="1" isChecked>
                    Import with an URL from DCUI (coming soon)
                  </Radio>
                </FormControl>
                {creationMode > 0 && (
                  <FormControl pt={3} id="importUrl" isRequired>
                    <FormLabel>Import URL</FormLabel>
                    <Input
                      name="importUrl"
                      type="text"
                      value={importUrl}
                      onChange={(e) => setImportUrl(e.target.value)}
                      required
                      placeholder={
                        publicComicImportSources[creationMode].urlFormat
                      }
                      tabIndex={1}
                    />
                  </FormControl>
                )}
                <Text py="3" fontSize="sm">
                  If you cannot import via a URL from Marvel.com, feel free to
                  email us the details at{" "}
                  <a href="mailto:contact@redwing.app">contact@redwing.app</a>
                </Text>
                {/* {creationMode === "0" && <ComicForm handleSubmit={() => {}} />} */}
              </Box>
            ) : (
              <Box>
                <Text pb="3">
                  The comic has been added, you can now get back to editing your
                  reading order and search for it.
                </Text>
                <Flex>
                  <Box width="200px">
                    <Image
                      src={comic.thumbnail}
                      alt={comic.title}
                      maxW="120px"
                      maxH="150px"
                    />
                  </Box>
                  <Box px="6" alignItems="flex-start" alignContent="flex-start">
                    <Text fontWeight="bold" fontSize="lg">
                      {comic.title}
                    </Text>
                    <Text fontSize="sm" noOfLines={3}>
                      {comic.description}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            <Button tabIndex={6} onClick={onClose}>
              Close
            </Button>
            {!comic && (
              <Button
                colorScheme="red"
                color="white"
                tabIndex={5}
                ml="3"
                type="submit"
                isLoading={isLoading}
                loadingText="Importing comic..."
              >
                Submit comic
              </Button>
            )}
            {!!comic && (
              <Button
                colorScheme="red"
                color="white"
                tabIndex={5}
                ml="3"
                onClick={() => resetForm()}
              >
                Submit another comic
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </form>
    </Modal>
  );
};

export default SubmitComicModal;
